import { api } from './api';

export interface WorkspaceConversationSummary {
  threadId: string;
  title: string;
  userId: string;
  userName?: string | null;
  userEmail?: string | null;
  messageCount: number;
  lastMessageAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedResult<T> {
  data: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface WorkspaceChatMessage {
  id: string;
  threadId: string;
  role: string;
  content: string;
  createdAt: string;
}

export interface ConversationHistoryQuery {
  page: number;
  pageSize: number;
  search?: string;
}

class WorkspaceChatHistoryService {
  async getHistory(
    workspaceId: string,
    query: ConversationHistoryQuery
  ): Promise<PaginatedResult<WorkspaceConversationSummary>> {
    const params = new URLSearchParams();
    params.append('page', String(query.page));
    params.append('pageSize', String(query.pageSize));

    if (query.search && query.search.trim()) {
      params.append('search', query.search.trim());
    }

    const response = await api.get<PaginatedResult<WorkspaceConversationSummary>>(
      `/workspaces/chats/workspace/${workspaceId}/history?${params.toString()}`
    );

    return response.data;
  }

  async getThreadMessages(threadId: string): Promise<WorkspaceChatMessage[]> {
    const response = await api.get<WorkspaceChatMessage[]>(`/workspaces/chats/threads/${threadId}`);
    const raw = response.data;
    return Array.isArray(raw) ? raw : [];
  }
}

export const workspaceChatHistoryService = new WorkspaceChatHistoryService();
